import { render, staticRenderFns } from "./DataExportIndex.vue?vue&type=template&id=3883e747&"
import script from "./DataExportIndex.vue?vue&type=script&lang=js&"
export * from "./DataExportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports